'use client';

import ChevronDown from '@/assets/icons/chevron-down.svg';
import HeroImage from '@/assets/images/hero.svg';
import { sherryLogoParser } from '@/lib/sherry-logo-parser';
import { cn } from '@/lib/utils';

export default function Hero({ className }: { className?: string }) {
  return (
    <section className={cn('pt-6 px-3', className)}>
      <div className="py-20 rounded-xl bg-gradient-primary text-white">
        <h1 className="text-2xl font-bold leading-8 text-center">
          행사는
          <br />
          {sherryLogoParser({ text: 'Sherry 하나만으로 종-결' })}
        </h1>
        <small className="mt-6 text-sm font-medium leading-5 opacity-70 text-center block">
          부스 운영의 불편함을 해결해주는 부스 도우미 Sherry
        </small>
        <div className="mt-10 h-60 flex justify-center items-center">
          <HeroImage className="relative r-4 overflow-visible" />
        </div>
      </div>

      <div className="pt-3 pb-3 text-center animate-bounce-min">
        <a href="#price" className="text-primary">
          지금 바로 무료 체험하기
        </a>
        <ChevronDown className="mx-auto" />
      </div>
    </section>
  );
}
